/**
 *
 * Asynchronously loads the component for UserGuide
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UserGuide = lazyLoad(
  () => import('./index'),
  module => module.UserGuide
);
